export const STOP_LOADING_SCHOOL = "STOP_LOADING_SCHOOL";
export const GET_SCHOOL_DATA = "GET_SCHOOL_DATA";
export const SET_SCHOOL_DATA = "SET_SCHOOL_DATA";
